import { render } from "./TicketTemplateChange.vue?vue&type=template&id=9dc3dc60&scoped=true"
import script from "./TicketTemplateChange.vue?vue&type=script&lang=js"
export * from "./TicketTemplateChange.vue?vue&type=script&lang=js"

import "./TicketTemplateChange.vue?vue&type=style&index=0&id=9dc3dc60&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc3dc60"]])

export default __exports__